import axios from 'axios';
import * as Cookies from '../utils/cookies';

export async function removeFromTeam(league_pk, team_pk, userId) {
  const token = Cookies.getToken();

  const res = await axios({
    method: 'POST',
    url:
      process.env.REACT_APP_API_URL +
      `/api/league/leagues/${league_pk}/teams/${team_pk}/players/${userId}/remove/`,
    headers: { Authorization: `Bearer ${token}` },
  });

  if (res.status === 201) {
    return res.data;
  } else {
    return { error: res.status };
  }
}

